import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import { useEntitiesCreate, useProfileUpdate } from '../../../../hooks';
import { autocompleteEntities } from '../../../../utils/backend-api/entities';
import { AutoSave, Divider } from '../../../BaseUI';
import { MultiValueAutocompleteField } from '../../../FormFields';
import TopicsSchema from './TopicsSchema';

const Topics = ({ userId, topics, isDisabled }) => {
  const initialState = useMemo(
    () => ({
      topics: topics || [],
    }),
    [topics]
  );
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();
  const { saveProfile, showSave, saveStatus } = useProfileUpdate(userId);

  const handleSubmit = ({ topics }) => {
    const sanitizedParams = { topics: topics.map((i) => i.value) };
    saveProfile(sanitizedParams);
  };

  return (
    <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={TopicsSchema}>
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          <div className="Topics section-container">
            <div className="section-header mt-2">Topics You Follow on The Information</div>
            <div className="section-detail">
              <div className="section-detail-container">
                {showSave && (
                  <div className={`save-label ${saveStatus === 'Saved' ? 'success' : 'failure'}`}>
                    {saveStatus}
                  </div>
                )}
              </div>
              <div className="section-form-container">
                <MultiValueAutocompleteField
                  placeholder="Type Topics"
                  label="My Topics"
                  name="topics"
                  isDisabled={isDisabled}
                  fetchMethod={(value) =>
                    autocompleteEntities({
                      fragment: value,
                      // entity_sources that article entity_joins have
                      entity_sources: ['manual', 'topic', 'google'],
                      order_entities_by: ['is_important', 'pdl_verified'],
                    })
                  }
                  createMethod={(value) =>
                    createEntityAsync({
                      name: value,
                      entity_type: 'other',
                      word_type: 'common',
                    })
                  }
                />
              </div>
            </div>
            <Divider />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Topics;
